'use strict';

import GraphQL from './graphql';

export default {

  get () {
    const query = `{
      favorites() {
        edges {
          node {
            id
            favoriteable_type
            favoriteable_id
            display_name
            path
          }
        }
      }
    }`;

    return GraphQL.post(query);
  },

  add (id, type) {
    const query = `mutation {
      addFavorite(favoriteableId: ${id}, favoriteableType: "${type}") {
        id
      }
    }`;

    return GraphQL.post(query);
  },

  destroy (id,  type) {
    const query = `mutation {
      removeFavorite(favoriteableId: ${id}, favoriteableType: "${type}") {
        id
      }
    }`;

    return GraphQL.post(query);
  }

};



// WEBPACK FOOTER //
// ./app/javascript/vue/services/favorites.js